'use strict';

export default function f($rootScope, $state) {
  'ngInject';

  return {
    init() {

      $rootScope.$on('$stateChangeSuccess', () => {
        this.set($state.$current.locals.globals.meta);
      });
    },

    set(meta = {}) {
      $rootScope.meta = meta;
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/meta.js